<template>
  <main class="main">
    <div class="anim-wrap">
      <div class="mono-logo-container text-center">
        <img src="@/assets/logo_white.svg" alt="Traitstack" />
      </div>
      <div class="field-error" :class="{ toggled: error }">
        {{ errorMessage }}
      </div>
      <div id="authPanel" class="panel auth-panel">
        <h1 class="h2">Sign in</h1>
        <div v-if="phase == 0">
          <form v-on:submit.prevent>
            <input
              ref="email"
              type="text"
              name="email"
              v-model="email"
              class="form-control"
              placeholder="Email address"
            />
            <input
              type="password"
              name="password"
              v-model="password"
              class="form-control"
              placeholder="Password"
            />
            <b-button
              ref="button"
              name="submit"
              type="submit"
              @click="signIn"
              variant="primary"
              class="btn-auth btn-loader"
              :class="{ active: loading, success: success }"
              ><span>Sign in</span></b-button
            >
          </form>

          <p class="auth-info" style="margin-top: 20px">
            Unable to sign in?
            <router-link to="/reset-password">Reset your password</router-link>
          </p>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
// FireBase
import firebase from "firebase/app";
import "firebase/auth";
export default {
  name: "signin",
  components: {},
  mounted() {
    this.$refs.email.focus();
  },
  data() {
    return {
      email: "",
      password: "",
      loading: false,
      error: false,
      errorMessage: "",
      success: false,
      phase: 0,
      emailAddress: "",
    };
  },
  methods: {
    resetErrorState() {
      this.loading = false;
      this.success = false;
      this.error = false;
    },
    displayErrorPanelWithMessage(message) {
      this.errorMessage = message;
      this.loading = false;
      this.error = true;
      document.getElementById("authPanel").classList.remove("error");
      void document.getElementById("authPanel").offsetWidth;
      document.getElementById("authPanel").classList.add("error");
    },
    signIn: function() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(
          () => {
            this.loading = false;
            this.success = true;
            this.error = false;
            this.$router.replace({ path: "/" });
          },
          (error) => {
            this.displayErrorPanelWithMessage(error.message);
          }
        );
    },
  },
};
</script>
